import { appMethod as app } from '@utils/app';
import { convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './MyIntegral.less';

export default class MyIntegral extends OfficialPage {
  state = {
    integralPage: 0, // 控制是否展开 0:显示主页 1:显示积分规则页
    canUseIntegral: 0, // 现有积分
    totalIntegral: 0, // 总积分
    integralFontSize: 60, // 根据积分长度改变积分字体大小
    currentMessageType: 'income', // income:收入 / outcome:支出
    navFixed: false, // 固定导航条
    integralRule: {
      convertNum: 100, // xx积分对应1元
      consumeNum: 0, // 消费xx元积累1积分
      loginNum: 0, // 每天登录送xx积分
      postCommentNum: 0, // 商品评论送xx积分
      shareNum: 0 // 推荐好友送xx积分
    },
    incomeBranch: {
      data: [],
      isMore: 0,
      currentPage: 1,
      onload: false
    },
    outcomeBranch: {
      data: [],
      isMore: 0,
      currentPage: 1,
      onload: false
    }
  }
  headHeight = 180
  
  constructor(props) {
    super(props);
    document.title = '个人积分';
  }

  componentWillMount() {
    this.getIntegralDetailData()
    this.getIntegralRuleData()
    this.getMessageData('income')
    this.getMessageData('outcome')
    this.headHeight =
      360 /
      (app.globalData.systemInfo && app.globalData.systemInfo.rpxRatio
        ? app.globalData.systemInfo.rpxRatio
        : 2)
  }

  getIntegralDetailData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      success: function (res) {
        let integralLength =
          ('' + res.data.can_use_integral).length +
          ('' + res.data.total_integral).length
        let fontSize = integralLength > 0 ? 60 - integralLength * 2 : 60
        that.setData({
          canUseIntegral: res.data.can_use_integral,
          totalIntegral: res.data.total_integral,
          integralFontSize: fontSize
        })
      }
    })
  }
  getIntegralRuleData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/IntegralRule',
      success: function (res) {
        that.setData({
          'integralRule.convertNum': res.data.convert_num || 0,
          'integralRule.consumeNum': res.data.consume_num,
          'integralRule.loginNum': res.data.login_num || 0,
          'integralRule.postCommentNum': res.data.post_comment_num,
          'integralRule.shareNum': res.data.share_num
        })
      }
    })
  }
  getMessageData = (type, page) => {
    let that = this
    let action = ''
    if (type == 'income') {
      action = 'add'
    } else if ((type = 'outcome')) {
      action = 'minus'
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/UserIntegralAction',
      data: {
        action: action,
        page: page || 1
      },
      success: function (res) {
        switch (type) {
          case 'income':
            that.setData({
              'incomeBranch.data':
                (that.data.incomeBranch.data
                  ? that.data.incomeBranch.data.concat(
                    that.parseMessageData(res.data)
                  )
                  : that.parseMessageData(res.data)) || '',
              'incomeBranch.isMore': res.is_more,
              'incomeBranch.currentPage': res.current_page || '',
              'incomeBranch.onload': false
            })
            break
          case 'outcome':
            that.setData({
              'outcomeBranch.data':
                (that.data.outcomeBranch.data
                  ? that.data.outcomeBranch.data.concat(
                    that.parseMessageData(res.data)
                  )
                  : that.parseMessageData(res.data)) || '',
              'outcomeBranch.isMore': res.is_more,
              'outcomeBranch.currentPage': res.current_page || '',
              'outcomeBranch.onload': false
            })
            break
        }
      }
    })
  }
  parseMessageData = data => {
    var that = this
    let array = []
    let item = {}
    for (var i = 0; i < data.length; i++) {
      item = {
        content: data[i].content,
        num: data[i].num,
        time: data[i].time
      }
      array.push(item)
    }
    return array
  }
  checkMoreMessageData = () => {
    let that = this
    switch (that.data.currentMessageType) {
      case 'income':
        if (
          that.data.incomeBranch.isMore != 0 &&
          !that.data.incomeBranch.onload
        ) {
          that.getMessageData('income', that.data.incomeBranch.currentPage + 1)
          that.setData({
            'incomeBranch.onload': true
          })
        }
        break
      case 'outcome':
        if (
          that.data.outcomeBranch.isMore != 0 &&
          !that.data.outcomeBranch.onload
        ) {
          that.getMessageData(
            'outcome',
            that.data.outcomeBranch.currentPage + 1
          )
          that.setData({
            'outcomeBranch.onload': true
          })
        }
        break
    }
  }
  fixedMessageNav = event => {
    var that = this
    if (event.target.scrollTop <= this.headHeight) {
      that.setData({
        navFixed: false
      })
    } else {
      that.setData({
        navFixed: true
      })
    }
  }
  setCurrentMessageType = event => {
    this.setData({
      currentMessageType: event.target.dataset.type
    })
  }
  showIntegralRule = () => {
    app.setPageTitle('积分规则')
    this.setData({
      integralPage: 1
    })
  }
  hideIntegralRule = () => {
    app.setPageTitle('个人积分')
    this.setData({
      integralPage: 0
    })
  }
  gotoRecharge = () => {
    app.turnToPage('/gptrecharge')
  }

  render() {
    const {
      showGetUserInfo,
      integralFontSize,
      canUseIntegral,
      totalIntegral,
      currentMessageType,
      navFixed,
      incomeBranch,
      outcomeBranch,
      integralPage,
      integralRule
    } = this.state
    return (
      <div className="official-page my-integral">
        <TopNav title="个人积分"/>
        <div className="myIntegral-wrap page" id="myIntegral">
          {integralPage == 0 && (
            <ScrollView
              className="myIntegral-content"
              bindscroll={this.fixedMessageNav}
              scroll-y="true"
              lowerThreshold="116"
              bindscrolltolower={this.checkMoreMessageData}
            >
              <div className="integral-detail">
                <div>
                  <img
                    src="https://cdn.jisuapp.cn/zhichi_frontend/static/jisuapp_editor/images/integralBg.png"
                    className="integral-bg-img"
                  />
                </div>
                <div className="integral-card-bg"></div>
                <div className="integral-card">
                  <div className="integral-detail-circle"></div>
                  <div
                    className="detail-num"
                    style={convertLineStyleData('font-size:' + integralFontSize + 'rpx')}
                  >
                    <span>{canUseIntegral + ' / ' + totalIntegral}</span>
                  </div>
                  <div className="detail-name">
                    <span>现有积分/总积分</span>
                  </div>
                  <div className="integral-detail-bottomline"></div>
                </div>
                <div className="integral-recharge" onClick={this.gotoRecharge}>
                  <span>去充值</span>
                </div>
                <div className="detail-rule" onClick={this.showIntegralRule}>
                  <span>积分规则</span>
                  <div className="single-icon">?</div>
                </div>
              </div>
              <div className="message-nav">
                <div
                  className={
                    'type-item ' +
                    (currentMessageType == 'income' ? 'active' : '')
                  }
                  onClick={this.setCurrentMessageType}
                  data-type="income"
                >
                  收入
                </div>
                <div
                  className={
                    'type-item ' +
                    (currentMessageType == 'outcome' ? 'active' : '')
                  }
                  onClick={this.setCurrentMessageType}
                  data-type="outcome"
                >
                  支出
                </div>
              </div>
              <div
                className={'message-nav ' + (navFixed ? 'fixed' : 'nofixed')}
              >
                <div
                  className={
                    'type-item ' +
                    (currentMessageType == 'income' ? 'active' : '')
                  }
                  onClick={this.setCurrentMessageType}
                  data-type="income"
                >
                  收入
                </div>
                <div
                  className={
                    'type-item ' +
                    (currentMessageType == 'outcome' ? 'active' : '')
                  }
                  onClick={this.setCurrentMessageType}
                  data-type="outcome"
                >
                  支出
                </div>
              </div>
              <div
                className={
                  'message-content ' +
                  (currentMessageType == 'income' ? 'active' : '')
                }
              >
                {incomeBranch.data.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="message-item">
                        <div className="message-title">{item.content}</div>
                        <div className="message-time">{item.time}</div>
                        <div className="message-num">{item.num}</div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
              <div
                className={
                  'message-content ' +
                  (currentMessageType == 'outcome' ? 'active' : '')
                }
              >
                {outcomeBranch.data.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="message-item">
                        <div className="message-title">{item.content}</div>
                        <div className="message-time">{item.time}</div>
                        <div className="message-num">{item.num}</div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </ScrollView>
          )}
          {integralPage == 1 && (
            <div className="myIntegral-rule">
              <div className="rule-list">
                {!!+integralRule.consumeNum && integralRule.consumeNum != 0 && (
                  <div className="rule-item">
                    <div className="item-name">积累规则</div>
                    <div className="item-content">
                      {'消费 ' + integralRule.consumeNum + ' 元，获得 1 积分'}
                    </div>
                  </div>
                )}
                {integralRule.loginNum != 0 && (
                  <div className="rule-item">
                    <div className="item-name">额外积分</div>
                    <div className="item-content">
                      {'每天登录送 ' + integralRule.loginNum + ' 积分'}
                    </div>
                  </div>
                )}
                {integralRule.shareNum != 0 && (
                  <div className="rule-item">
                    <div className="item-name">额外积分</div>
                    <div className="item-content">
                      {'推荐好友送 ' + integralRule.shareNum + ' 积分'}
                    </div>
                  </div>
                )}
                {integralRule.postCommentNum != 0 && (
                  <div className="rule-item">
                    <div className="item-name">额外积分</div>
                    <div className="item-content">
                      {'商品评论送 ' + integralRule.postCommentNum + ' 积分'}
                    </div>
                  </div>
                )}
                <div className="rule-item">
                  <div className="item-name">使用积分</div>
                  <div className="item-content">
                    {(integralRule.convertNum || '100') + ' 积分 = 1元'}
                  </div>
                </div>
                <div className="rule-item">
                  <div className="item-name">提醒</div>
                  <div className="item-content">
                    消费积分并不会影响升级会员卡，与会员升级相关的是总积分
                  </div>
                </div>
              </div>
              <div className="confirm-btn" onClick={this.hideIntegralRule}>
                确定
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/my-integral/MyIntegral.jsx